<template>
  <v-dialog persistent scrollable class="dialog" v-model="isActive" width="600">
    <v-card>
      <v-card-title class="blue darken-2 white--text headline">新規会計</v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" class="px-3">
                <v-text-field required counter
                  ref="name"
                  v-model="form.name"
                  maxlength="20"
                  label="会計名"
                  :rules="rules.name"
                  @keypress.enter.prevent="submit"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary white--text"
          :disabled="!isValid"
          :loading="isLoading"
          @click="submit">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'insertModal',
  props: [
    'cid'
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      meta: {
      },
      form: {
        valid: true,
        name: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        name: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
      this.$nextTick(() => {
        this.$refs.name.focus()
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      const cid = this.$props.cid || this.$route.params.id || ''
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}cbook/insert/item/${cid}`, {
            cid,
            name: this.form.name.replace('/', '-').trim()
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.$emit('done', res.data.data)
              this.close()
            }
          })
        })
      }
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    }
  }
}
</script>
